<div id="myReactComponentContainer" #myReactComponentContainer>

</div>
